import styled from "styled-components/macro";

import { motion } from "framer-motion";

import FnrIcon, { FnrIconWrapper } from "UI/FnrIcon";

import { formatNumberWithCommas } from "Utilities/Number";

import DesignationLink from "./DesignationLink";

export default function Designations({ designations = [], show }) {
  return (
    <Container>
      <ListWrapper animate={show ? { opacity: 1, height: "auto" } : null}>
        <ListInside>
          {designations.map((d) => (
            <Designation key={d.designationID} {...d} />
          ))}
        </ListInside>
      </ListWrapper>
    </Container>
  );
}

const Container = styled.div`
  padding-left: 60px;
  padding-right: 14px;
`;
const ListWrapper = styled(motion.div)`
  background: rgba(0, 0, 0, 0.1);
  .mobile & {
    background: rgba(0, 0, 0, 0.2);
  }
  border-radius: 6px;
  overflow: hidden;
  opacity: 0;
  height: 0;
`;
const ListInside = styled.div`
  padding: 4px 6px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

function Designation({
  fundName,
  amount,
  campaignName,
  fundID,
  paymentsEnabled,
}) {
  const { whole, decimal } = amount;

  return (
    <Wrapper>
      <DesignationLink paymentsEnabled={paymentsEnabled} fundID={fundID}>
        <Name>
          {campaignName || fundName}{" "}
          {campaignName && (
            <PledgeIndicator>
              <FnrIcon fad fa-hand-holding-usd />
            </PledgeIndicator>
          )}
        </Name>
      </DesignationLink>

      <Amount>
        <TotalNumber>
          <WholeNumber>{formatNumberWithCommas(whole)}</WholeNumber>
          <DecimalNumber>{decimal}</DecimalNumber>
        </TotalNumber>
      </Amount>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`;
const A = styled.a`
  text-decoration: none !important;
`;

const Name = styled.div`
  font-size: 14px;
  display: flex;
  align-items: center;
  opacity: 0.9;
  .mobile & {
    opacity: 0.8;
  }
  transition: opacity 0.2s, transform 0.2s;
  A:hover & {
    opacity: 1 !important;
  }
  A:active & {
    scale: 0.96;
  }
`;

const Amount = styled.div`
  text-align: right;
  font-weight: 400;
  position: relative;
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

const TotalNumber = styled.span`
  display: flex;
  align-items: flex-start;
  font-variant-numeric: tabular-nums;
`;

const WholeNumber = styled.span`
  font-size: 16px;
  line-height: 16px;
  &:before {
    content: "$";
  }
`;

const DecimalNumber = styled.span`
  font-size: 11px;
  line-height: 11px;
  margin-left: 1px;
  padding-right: 1px;
`;
const PledgeIndicator = styled.div`
  margin-left: 4px;
  font-size: 10px;
  display: inline-block;
  position: relative;
  & ${FnrIconWrapper} {
    position: absolute;
    margin-top: -6px;
  }
`;
